import React, { useMemo } from 'react';
import { SupabasePersistor } from '../persistence/SupabasePersistor';
import { PersistorProvider } from '../persistence/PersistorContext';
import { useAuth } from '../auth/AuthorizerContext';

/**
 * Builds the hosted app's Supabase-backed persistor and hands it to the dumb
 * {@link PersistorProvider}. Everything that imports `@supabase/supabase-js` for
 * persistence lives behind this module, so a viewer that renders
 * `PersistorProvider` directly never pulls the client into its bundle.
 */
export const SupabasePersistorProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const { supabase } = useAuth();
	const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || '';

	const persistor = useMemo(() => {
		if (!supabaseUrl) {
			throw new Error('Missing VITE_SUPABASE_URL environment variable');
		}
		return new SupabasePersistor(supabase);
	}, [supabase, supabaseUrl]);

	return (
		<PersistorProvider persistor={persistor} managementPersistor={persistor}>
			{children}
		</PersistorProvider>
	);
};
